// Local SS58 address encoder (base58 + blake2b-512 checksum, network prefix
// 54 = Cere). Replaces @polkadot/util-crypto's `encodeAddress` so the vault UI
// no longer depends on any @polkadot/* package. Mirrors the marketplace
// migration plan's lib/encoding/ss58.ts encoder byte-for-byte.
import { blake2b } from '@noble/hashes/blake2b';

const ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
const SS58_PREFIX = new TextEncoder().encode('SS58PRE');

function base58encode(bytes: Uint8Array): string {
  let x = 0n;
  for (const b of bytes) x = (x << 8n) + BigInt(b);
  let out = '';
  while (x > 0n) {
    out = ALPHABET[Number(x % 58n)] + out;
    x /= 58n;
  }
  for (const b of bytes) {
    if (b === 0) out = ALPHABET[0] + out;
    else break;
  }
  return out;
}

/** Encode a 32-byte ed25519 pubkey as a Cere SS58 address (network prefix 54). */
export function encodeSs58(pubkey: Uint8Array, prefix = 54): string {
  const prefixBytes = prefix < 64 ? Uint8Array.of(prefix) : Uint8Array.of(); // Cere = 54, single-byte
  const payload = new Uint8Array(prefixBytes.length + pubkey.length);
  payload.set(prefixBytes, 0);
  payload.set(pubkey, prefixBytes.length);
  const checksum = blake2b(new Uint8Array([...SS58_PREFIX, ...payload]), { dkLen: 64 }).slice(0, 2);
  const full = new Uint8Array(payload.length + 2);
  full.set(payload, 0);
  full.set(checksum, payload.length);
  return base58encode(full);
}
